import React from 'react';
import MobileItem from './MobileItem';
import { observer } from 'store';
import * as styles from './counter.module.scss';

function Mobile({ items, values, onChangeCount }) {
  return (
    <ul className={styles.list}>
      {items.map(item => (
        <MobileItem key={item} title={item} value={values[item]} onChangeCount={onChangeCount} />
      ))}
    </ul>
  );
}

export default observer(Mobile);
